/**
 * Legacy photo lists of the sales cards (top-level fields of the project), shown and granted only
 * by the block project-sales-report-data. Must match `PROJECT_SALES_REPORT_PHOTO_FIELDS` in
 * apps/apolloserver (services/projectBlocks.ts).
 */
export const PROJECT_SALES_REPORT_PHOTO_FIELDS = [
  'salesRoofSidesAttachments',
  'salesHakAttachments',
  'salesZsWithCoverAttachments',
];
